<template>
    <div id="app">
        <img 
            :src="imageUrl" 
            :alt="alt" 
            @click="openFilePicker"/>

        <div v-if="isEditing">
            <image-uploader
                :showModal="showModal"
                @imageChanged="onImageChanged"
                @closeModal="showModal = false"
            />
        </div>
    </div>
</template>
  
<script>

import { getEventImage } from '@/api/events.js';
import ImageUploader from '@/components/common/ImageUploader.vue';
import { getActivityImage } from '../../api/activity';

export default {
name: 'EventImage',
components: {
    ImageUploader,
},
props: {
    eventId: {
        type: [Number,null],
        required: false,
    },
    activityId: {
        type: [Number,null],
        required: false,
    },
    alt: {
        type: String,
        required: false,
    },
    isEditing: {
        type: Boolean,
        required: false,
    },
},

emits: ['imageChanged'],

data() {
    return{
        imageUrl: null,
        showModal: false,
        selectedFile: null,
    }
},

methods: {
    async fetchImage() {

        try {
            // Fetch image data as blob from the API
            const imageBlob = 
                (this.eventId == 0 || this.eventId == null )?
                    await getActivityImage(this.activityId) :
                    await getEventImage(this.eventId);

            // Revoke any previous object URL to avoid memory leaks
            if (this.imageUrl) {
                URL.revokeObjectURL(this.imageUrl);
            }

            // Create an object URL from the blob and assign it to imageUrl
            this.imageUrl = URL.createObjectURL( imageBlob);
        } catch (error) {
            console.error('Error fetching the image:', error);
            this.error = "Failed to load image. Please try again.";
            this.imageUrl = null;
        }
    },

    onImageChanged(selectedFile) {
      // Handle the updated image URL
      if (this.imageUrl) {
        URL.revokeObjectURL(this.imageUrl); // Revoke old object URL
      }
      this.imageUrl = URL.createObjectURL(selectedFile); // Assign the new image URL
      this.selectedFile = selectedFile;
      this.$emit('imageChanged', selectedFile);
    },

    openFilePicker() {
      // Open the modal popup when the image is clicked
      this.showModal = true;
      this.error = null;
    },
},

created() {
    this.fetchImage();
},

};
</script>